let env: any  = process.env.REACT_APP_STAGE;

export const STAGES = {
    LOCAL: 'LOCAL',
    DEV: 'DEV',
    PROD: 'PROD',
}


let _API_  = {
    CORE: 'https://desarrollo.ws-voices.com.mx/',
    SOCKET: 'https://desarrollo.ws-voices.com.mx:3009',
    BOT_V2: 'https://bot.ws-voices.com.mx:3116/',
    BOT_V3: 'http://localhost:8080/',
    PAYMENTS: 'http://localhost:8081/',
    META_SERVICES: 'http://localhost:8082/',
}

let _AGENT_SITE_ = 'http://localhost:4100/auth/validate?token=';
let _AGENT_SITE_COPPEL_ = 'http://localhost:4100/auth/validate?token=';

let _ENV_NAME_ = STAGES.LOCAL;

switch (env) {
    case 'dev':
        _API_  = {
            CORE: 'https://desarrollo.ws-voices.com.mx/',
            SOCKET: 'https://desarrollo.ws-voices.com.mx:3009',
            BOT_V2: 'https://bot.ws-voices.com.mx:3116/',
            BOT_V3: 'https://bots.sandbox-api.ws-voices.com/',
            PAYMENTS: 'https://payments.sandbox-api.ws-voices.com/',
            META_SERVICES: 'https://meta.sandbox-api.ws-voices.com/',
        }
        _ENV_NAME_ = STAGES.DEV;
        _AGENT_SITE_ = 'https://agente-dev.ws-voices.com.mx/auth/validate?token=';
        _AGENT_SITE_COPPEL_ = 'https://agente-coppel.ws-voices.com/auth/validate?token=';

        // _API_  = {
        //     CORE: 'https://ws-api.ws-voices.com.mx/',
        //     SOCKET: 'https://ws-api.ws-voices.com.mx:3009',
        //     BOT_V2: 'https://bot.ws-voices.com.mx/',
        //     BOT_V3: 'https://bots.api.ws-voices.com/',
        //     PAYMENTS: 'https://payments.api.ws-voices.com/',
        //     META_SERVICES: 'https://meta.api.ws-voices.com/',
        // }
        // _ENV_NAME_ = STAGES.PROD;

        // _AGENT_SITE_ = 'https://agente.ws-voices.com.mx/auth/validate?token=';

        break;
    case 'prod':
        _API_  = {
            CORE: 'https://ws-api.ws-voices.com.mx/',
            SOCKET: 'https://ws-api.ws-voices.com.mx:3009',
            BOT_V2: 'https://bot.ws-voices.com.mx/',
            BOT_V3: 'https://bots.api.ws-voices.com/',
            PAYMENTS: 'https://payments.api.ws-voices.com/',
            META_SERVICES: 'https://meta.api.ws-voices.com/',
        }
        _ENV_NAME_ = STAGES.PROD;

        _AGENT_SITE_ = 'https://agente.ws-voices.com.mx/auth/validate?token=';
        _AGENT_SITE_COPPEL_ = 'https://agente-coppel.ws-voices.com/auth/validate?token=';
        break;

    default:
        break;
}

export const API_ENDPOINT = _API_;
export const AGENT_SITE = _AGENT_SITE_;
export const AGENT_SITE_COPPEL = _AGENT_SITE_COPPEL_;
export const ENV_NAME = _ENV_NAME_;


export const STORAGE_PREFIX = 'voices-wa-';

export const STORAGE = {
    TOKEN: STORAGE_PREFIX + 'token',
    SESSION: STORAGE_PREFIX + 'session',
    ACCOUNTS_ASSIGNED: STORAGE_PREFIX + 'accounts',
    ACCOUNT_SELECTED: STORAGE_PREFIX + 'current-account',
    SESSION_AGENT: STORAGE_PREFIX + 'session-agent',
    PERMISSIONS: STORAGE_PREFIX + 'permissions',
    SUPPORT_DATA: STORAGE_PREFIX + 'support-data',
}

export const BOT_VERSIONS = {
    V2: '2.0',
    V3: '3.0',
}

export const BOT_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    NOT_SHOW: 'not_show',
}

export const PROFILES = {
    ADMIN: 'admin',
    SUPERVISOR: 'supervisor',
    AGENTE: 'agente',
    ROOT: 'root',
    IVR: 'ivr',
    INICIADOR: 'iniciador',
    BOT: 'bot',
}
export const PERMISSIONS_SUPERVISOR = {
    DASHBOARD: 'dashboard',
    REPORTES: 'reportes',
    USUARIOS: 'usuarios',
    CUENTAS: 'cuentas',
    BASE: 'base',
    PAGOS: 'pagos',
}

export const OPTIONS_ACCOUNTS = {
    SUBACCOUNTS: 'subaccounts',
    FORMS: 'forms',
    TICKETS: 'tickets',
    TEMPLATES: 'templates',
    ALERTS: 'alerts',
    STATUS: 'status',
    SCHEDULES: 'schedules',
    MESSAGES: 'messages',
    PERMISSIONS: 'permissions',
    FOLLOWUP:'followup',
    BLACKLIST: 'blacklist',
}  
export const REGEX = {
    BOLD: /[*]+[\s\a-zA-Z0-9]+[*]/,
    ITALIC: /[_]+[\s\a-zA-Z0-9]+[_]/,
    TRHOUHGHTLINE: /[~]+[\s\a-zA-Z0-9]+[~]/,
}

export const APPS = {
    WHATSAPP_STANDAR: 'WHATSAPP',
    WHATSAPP_BUSINESS: 'WA-BUSINESS',
    RCS: 'RCS',
    CALL: 'CALL',
    SMS: 'SMS',
}

export const SUPPORT_LINKS = {
    REPORTES_TICKETS: 'reportes_tickets',
    REPORTES_AGENTES: 'reportes_agentes',
    REPORTES_PAGOS: 'reportes_pagos',
    REPORTES_CLIENTES: 'reportes_clientes',
    BASECLIENTES: 'baseclientes',
    ENVIOMASIVO: 'enviomasivo',
    CONFIGURACION: 'configuracion',
    CANALES: 'canales',
    USUARIOS: 'usuarios',
    PAGOS: 'pagos',
    CHATBOT: 'chatbot',
}
export const TYPE_MESSAGES = {
    SYSTEM: 'SYSTEM'
}
